import './aws';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@aws-amplify/ui-react';

import '@aws-amplify/ui-react/styles.css';
import '@aws-amplify/ui-react-liveness/styles.css';

import './styles.css';
import FaceLiveness from './FaceLiveness';
import { navyTheme } from './theme/theme';

let root = null;

function render(sessionId, resultUrl = '/rekognition/liveness/result') {

    window.sessionId = sessionId;

    const container = document.getElementById('rekognition-app');

    if (!container) return;

    if (!root) {
        root = createRoot(container);
    }

    root.render(
        <ThemeProvider theme={navyTheme}>
            <FaceLiveness resultUrl={resultUrl} />
        </ThemeProvider>
    );
}

window.Rekognition = {

    iniciar(sessionId, resultUrl) {
        render(sessionId, resultUrl);
    },

    destruir(){

        if(root){
            root.unmount();
            root = null;
        }

        window.sessionId = null;
    }

};

// Compatibilidad con el blade antiguo
if (window.sessionId) {
    render(window.sessionId);
}
